export default {
  id: null,
  companyID: null,
  areaID: null,
  name: null,
  stateList: null,
  cityList: null,
  description: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/regionservicemodel.js